var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observer } from 'mobx-react';
import React from 'react';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { Box, Flex, FormControl, FormLabel, Input, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { ScaleLoader } from 'react-spinners';
export class ObjectRenameState {
    constructor() {
        this.basedialogState = new BaseDialogState();
        this.name = "";
        this.loading = false;
        this.error = "";
        makeObservable(this);
        this.basedialogState.setHeaderLabel("Rename Dialog");
        this.basedialogState.onOk = () => this.rename();
    }
    setName(name) {
        this.name = name;
        if (this.name.trim()) {
            this.basedialogState.setDisableOkButton(false);
        }
        else {
            this.basedialogState.setDisableOkButton(true);
        }
    }
    setError(error) {
        this.error = error;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    rename() {
        var _a;
        if (!this.name.trim()) {
            return;
        }
        this.setLoading(true);
        (_a = this.renamecb) === null || _a === void 0 ? void 0 : _a.call(this, this.name);
    }
    setOpen(open) {
        if (open) {
            this.setLoading(false);
            this.setError("");
        }
        this.basedialogState.setOpen(open);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectRenameState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectRenameState.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ObjectRenameState.prototype, "error", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectRenameState.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ObjectRenameState.prototype, "setError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ObjectRenameState.prototype, "setLoading", null);
let ObjectRename = class ObjectRename extends React.Component {
    constructor(prop) {
        super(prop);
    }
    dialog() {
        return React.createElement(Box, null,
            React.createElement(Flex, { w: '100%', align: 'center', justify: 'center' },
                React.createElement(Text, { color: 'red' }, this.props.state.error)),
            React.createElement(FormControl, { mt: '10px', id: 'rename-name' },
                React.createElement(FormLabel, null, "Name"),
                React.createElement(Input, { placeholder: 'Name', value: this.props.state.name, onChange: (e) => this.props.state.setName(e.currentTarget.value) })),
            this.props.state.loading && React.createElement(Flex, { justify: 'center', align: 'center', w: '100%' },
                React.createElement(ScaleLoader, { color: 'green' })));
    }
    render() {
        return (React.createElement(BaseDialog, { body: this.dialog(), state: this.props.state.basedialogState }));
    }
};
ObjectRename = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ObjectRename);
export { ObjectRename };
